import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/features/auth";
import { httpClient } from "@/shared/lib/httpClient";

interface UserInfo {
    id: string;
    name: string;
    email: string;
    role: string;
}

export function useIsAdmin(): boolean {
    const { user, isAuthenticated } = useAuth();
    
    // Usar React Query para cache e melhor gerenciamento de estado
    const { data: userInfo, isLoading } = useQuery<UserInfo>({
        queryKey: ["user-info"],
        queryFn: async () => {
            return httpClient.get<UserInfo>("/auth/me");
        },
        enabled: isAuthenticated && !!user,
        retry: 1,
        staleTime: 5 * 60 * 1000, // 5 minutos
        refetchOnWindowFocus: false,
    });

    // Retornar false enquanto carrega para evitar acesso prematuro
    if (isLoading) return false;
    
    // Retornar true apenas se o role for 'admin'
    return userInfo?.role === "admin";
}
